<h2 mat-dialog-title>Richiesta cambio medico</h2>

<mat-dialog-content>
  @if (successMessage) {
    <p role="status">{{ successMessage }}</p>
  } @else {
    <form [formGroup]="form" (ngSubmit)="search()" class="search-form">
      <mat-form-field>
        <mat-label>Cognome del medico</mat-label>
        <input matInput formControlName="cognome" autocomplete="off" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nome del medico (facoltativo)</mat-label>
        <input matInput formControlName="nome" autocomplete="off" />
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit" [disabled]="loading || sending || form.invalid">
        Ricerca medico
      </button>
    </form>

    @if (loading) {
      <p role="status">Ricerca in corso...</p>
    }
    @if (errorMessage) {
      <p class="error-message" role="alert">{{ errorMessage }}</p>
    }
    @if (searched && medici.length === 0) {
      <p role="status">Nessun medico trovato con i criteri inseriti.</p>
    }
    @if (medici.length > 0) {
      <p>Seleziona il medico a cui inviare la richiesta:</p>
      <div class="doctor-list">
        @for (medico of medici; track medico.codguid) {
          <button type="button" class="doctor-result"
                  [class.selected]="medicoSelezionato?.codguid === medico.codguid"
                  [attr.aria-pressed]="medicoSelezionato?.codguid === medico.codguid"
                  (click)="selectDoctor(medico)">
            <strong>{{ medico.cognome }} {{ medico.nome }}</strong>
            <!-- <span>CF: {{ medico.codfis }}</span> -->
            <span>Data di nascita: {{ medico.dataNascita || 'Non disponibile' }}</span>
            <span>{{ medico.citta }}{{ medico.citta && medico.regione ? ', ' : '' }}{{ medico.regione }}</span>
          </button>
        }
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">{{ successMessage ? 'Chiudi' : 'Annulla' }}</button>
  @if (!successMessage) {
    <button mat-raised-button color="primary" type="button" (click)="send()"
            [disabled]="!medicoSelezionato || sending || loading">Invia richiesta</button>
  }
</mat-dialog-actions>
